// export enum PermissionEnum {
//   '案件管理' = 1,
//   '客户管理',
//   '利冲检索',
//   '合同管理',
//   '用章管理',
//   '财务管理',
//   '审批管理',
//   '访问律协数据平台',
//   '个人名片',
//   '行业通讯录',
//   '异地查档协助中心',
//   '系统设置',
//   '委托广场',
//   '我发布的委托',
//   '通知公告',
//   '我帮助的委托',
//   '用户设置',
//   '审批设置',
//   '客户管理.查看',
//   '客户管理.删除',
//   '客户管理.编辑',
//   '访问律协数据平台.数据报送中心',
//   '访问律协数据平台.新闻投稿',
//   '访问律协数据平台.问卷调查',
//   '我的公益服务',
//   '本所公益服务申报',
//   '本所公益服务公示',
//   '我的公益服务证明',
//   '无行业处分证明',
//   '律师维权',
// }

export enum PermissionEnum {
  通知公告 = 1,
  个人公益服务管理,
  个人公益服务证明申请,
  无行业处分证明开具申请,
  我要维权,
  被调查会员情况说明,
  数据报送,
  本所律师公益服务申报,
  本所惩戒人员文档上报,
  用户设置,
  本所公益服务申报,
  本所公益服务管理,
  本所公益服务证明申请,
  需回执的通知,
  我的活动,
  学习课堂,
  律师变更执业机构审核,
  测试权限,
}
export enum RoleEnum {
  admin = 1,
  member,
}
